<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-12-09 13:35:14
 -->
<!--  -->
<template>
  <easyCruds
    ref="mainTable"
    :tableInfo="mainTable"
    @mainTableReload="mainTableReload"
    @saveRowByAddOrEdit="saveRowByAddOrEdit"
    @deleteRows="deleteRows"

  >

  </easyCruds>
</template>

<script>
export default {
  data() {
    return {
      mainTable: {
        header: { title: '登录失败策略管理' },
        buttonSetting: {
          allowAdd: true,
          addText: '新增登录失败策略',
          addCloseOnClickModal: true,
          allowEdit: true,
          editText: '编辑登录失败策略',
          editCloseOnClickModal: true,
          allowView: true,
          viewText: '查看登录失败策略',
          viewCloseOnClickModal: true,
          allowDelete: true,
          deleteFunctionName: 'deleteRows',
          addButtonArray: [{
            clickEvent: 'saveRowByAddOrEdit',
            type: 'primary',
            buttonName: '新增',
            validate: true
          }],
          editButtonArray: [{
            clickEvent: 'saveRowByAddOrEdit',
            type: 'primary',
            buttonName: '保存编辑',
            validate: true
          }]
        },
        table: {
          loading: false,
          height: 550,
          stripe: true,
          conditionLabelWidth: 'auto',
          selection: true,
          index: false,
          columns: [{
            prop: 'name',
            label: '策略名称',
            isSearchCondition: true,
            type: 'input',
            span: 12,
            required: true
          }, {
            prop: 'numberOfRetryLimit',
            label: '重试次数',
            type: 'number',
            controlsPosition: '',
            minRows: 1,
            maxRows: 20
          }, {
            label: '重置间隔',
            prop: 'resetFailureCountTime',
            type: 'input',
            required: true,
            append: '秒',
            'rules': [
              {
                'pattern': /^[1-9]\d*$/,
                'message': '请输入正整数'
              }
            ]

          }, {
            prop: 'status',
            label: '状态',
            width: '250',
            isTag: true,
            type: 'select',
            isSearchCondition: true,
            required: true,
            tagFilter: function(e) {
              if (e === 1) {
                return { data: '正常', type: 'success' }
              } else {
                return { data: '停用', type: 'warning' }
              }
            },
            dicData: [{
              'label': '正常',
              'value': 1
            }, {
              'label': '停用',
              'value': 2
            }]
          }, {
            label: '备注',
            prop: 'remark',
            type: 'input'
          }, {
            label: '处理类型',
            prop: 'handleType',
            isSearchCondition: true,
            type: 'select',
            dicData: [{
              label: '验证码',
              value: 1
            }, {
              label: '冻结账号',
              value: 2
            }],
            isTag: true,
            required: true,
            tagFilter: function(e) {
              if (e === 1) {
                return { data: '验证码', type: 'success' }
              } else if (e === 2) {
                return { data: '冻结账号', type: 'info' }
              } else {
                return { data: '未知类型', type: 'warning' }
              }
            }, onChange: (item, value, easyFormInfo) => {
              let setDD = (prop, bool) => {
                let temp = easyFormInfo.form.formItems.filter(item => item.prop === prop)
                temp[0].display = bool
              }
              if (value === 1) {
                // 验证码类型
                setDD('frozenType', false)
                setDD('frozenTime', false)
              } else {
                setDD('frozenType', true)
                setDD('frozenTime', true)
              }
            }
          },
          {
            label: '冻结类型',
            prop: 'frozenType',
            isSearchCondition: true,
            type: 'select',
            onChange: (item, value, easyFormInfo) => {
              let setDD = (prop, bool, append) => {
                let temp = easyFormInfo.form.formItems.filter(item => item.prop === prop)
                if (bool !== undefined) {
                  temp[0].display = bool
                }
                if (append !== undefined) {
                  temp[0].append = append
                }
              }
              if (value === 1) {
                setDD('frozenTime', true, '分')
              } else if (value === 2) {
                // 定时解冻
                setDD('frozenTime', true, '时解冻')
              } else if (value === 3) {
                // 永久冻结
                setDD('frozenTime', false, '永久冻结')
              }
            },
            dicData: [{
              label: '冻结固定时长',
              value: 1
            }, {
              label: '定时解冻',
              value: 2
            }, {
              label: '永久冻结',
              value: 3
            }],
            isTag: true,
            required: true,
            tagFilter: function(e) {
              if (e === 1) {
                return { data: '冻结固定时长', type: 'success' }
              } else if (e === 2) {
                return { data: '定时解冻', type: 'info' }
              } else if (e === 3) {
                return { data: '永久冻结', type: 'info' }
              } else {
                return { data: '未知冻结类型', type: 'warning' }
              }
            }
          }, {
            label: '冻结时间',
            prop: 'frozenTime',
            required: true,
            isSearchCondition: true,
            type: 'input'
          }],
          operation: {
            width: '220',
            operations: []
          },
          tableData: [],
          paging: {
            currentPage: 1,
            pageSizes: [15, 20, 25, 30],
            pageSize: 15,
            total: 0
          },
          reload: 'mainTableReload',
          reloadConditions: {},
          addDefultValue: {}
        }
      }
    }
  },

  components: { },

  mounted() {
    this.mainTableReload()
  },
  methods: {
    mainTableReload(params = { }) {
      this.mainTable.table.loading = true
      let { pageNum = 1, pageSize = 10 } = params
      this.$http.post('/login-failure-strategy/query', { entity: params }, {
        params: {
          pageNum,
          pageSize
        }
      }).then(response => {
        this.mainTable.table.loading = false
        /** Successful Business logic */
        this.mainTable.table.tableData = response.data.records
        this.mainTable.table.paging.total = response.data.total || response.data.records.length
      }).catch(error => {
        this.mainTable.table.loading = false
        this.$message.error(error.msg)
      })
    },
    saveRowByAddOrEdit(row, done, errDone, method) {
      this.$http[method === 'EDIT' ? 'put' : 'post']('/login-failure-strategy', [row]).then(response => {
        this.$message.success('操作成功！') && done()
        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
      }).catch(error => {
        this.$message.error(error.msg) && errDone()
      })
    },
    /** Delete data */
    deleteRows: function(deleteList) {
      /** Set mainTable dataTables to loading state */
      this.mainTable.table.loading = true
      this.$http.post('/login-failure-strategy/delete', null, {
        params: {
          strategyIdList: deleteList.map(item => item.id)
        }
      }).then(response => {
        this.mainTable.table.loading = false
        this.$message.success('删除登录失败策略成功')
        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
      }).catch(error => {
        this.mainTable.table.loading = false
        this.$message.error(error.msg)
      })
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
